import { observer } from 'mobx-react-lite'
import { Modal, Spinner } from 'react-bootstrap'
import { useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { history } from '../../..'
import { useStore } from '../../../app/stores/store'

function UnauthorizedBidder() {
  const { userStore, auctionDetailsStore, bidsStore } = useStore()
  const { auctionDetails } = bidsStore
  const useQuery = new URLSearchParams(useLocation().search)
  const { t } = useTranslation()
  const validateEmail = useQuery.get('validateEmail') as string
  const token = useQuery.get('token')?.replace(/ /g, '+') as string
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [authorization, setAuthorization] = useState({
    auctionId: '',
    token,
    validateEmail,
  })

  useEffect(()=>{
    if(auctionDetails?.id && !authorization.auctionId){
      authorization.auctionId = auctionDetails.id
      setAuthorization({
        ...authorization,
        auctionId : auctionDetails.id
      })
    }
  }, [auctionDetails])

  function authorizeUser() {
    setLoadingBtn(true)
    auctionDetailsStore.authorizeUser(authorization).finally(() => setLoadingBtn(false))
  }

  const handleLogout = () => {
    userStore.logout()
    history.push({
      pathname: '/login',
      search: new URLSearchParams(authorization).toString(),
    })
  }

  return (
    <Modal show={bidsStore.unauthorizedUser} backdrop='static' keyboard={false} size='lg' centered>
      <div className='newFont prevent-select'>
        <Modal.Header className='bg-white'>
          <p className='post-card-title'>{t('acc_unauthorized')}</p>
        </Modal.Header>
        <Modal.Body className='post-card-padding pt-5 card-font-size'>
          <p>{t('acc_authorize_desc1')}</p>
          <p>{t('acc_authorize_desc2')}</p>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleLogout} className='payment-button-cancel text-white'>
            {t('log_out')}
          </button>
          <button
            onClick={authorizeUser}
            className='payment-button-tryagain text-white'
            disabled={loadingBtn}
          >
            {loadingBtn ? <Spinner animation='border' variant='light' /> : t('authorize')}
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}
export default observer(UnauthorizedBidder)
